type OnboardingStepNumber = 1 | 2 | 3 | 4
export type OnboardingStepDisplayMode = 'fullFlow' | 'remainingFlow'

type ComputeOnboardingStepDisplayArgs = {
  currentStep: number
  initialStep: number
  stepDisplayMode: OnboardingStepDisplayMode
}

export const computeOnboardingStepDisplay = ({
  currentStep,
  initialStep,
  stepDisplayMode,
}: ComputeOnboardingStepDisplayArgs): {
  displayStep: number
  totalSteps: number
} => {
  const steps: OnboardingStepNumber[] = [1, 2, 3, 4]

  let displaySteps = steps

  if (stepDisplayMode === 'remainingFlow') {
    const remainingSteps = steps.filter((step) => step >= initialStep)
    displaySteps = remainingSteps.length > 0 ? remainingSteps : steps
  }
  const displayStep =
    displaySteps.indexOf(currentStep as OnboardingStepNumber) + 1

  return {
    displayStep: displayStep > 0 ? displayStep : displaySteps.length,
    totalSteps: displaySteps.length,
  }
}
